import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductsListComponent } from './products-list.component';
import { ProductsDetailComponent } from './products-detail/products-detail.component';
import {
  ProductsAnalyticsComponent,
  ProductsFormComponent,
  ProductsReviewsComponent,
  ProductsQuestionsComponent,
  ProductsStoresComponent,
  ProductsDocumentsComponent,
  ProductsDistributorsComponent,
  ProductsSettingComponent, SettingMessageComponent, SettingRelatedComponent,
  ProductsHistoryComponent,
  ProductsElabelComponent,
  ProductsElabelHistoryComponent
} from 'src/app/business/products/products-detail';
import {ProductLoyaltyComponent} from './products-detail/product-loyalty/product-loyalty.component';
import {DetailProductPassportComponent} from './detail-product-passport/detail-product-passport.component';

const routes: Routes = [
  {
    path: '',
    component: ProductsListComponent,
  },
  {
    path: 'passport/:id',
    component: DetailProductPassportComponent,
  },
  {
    path: ':id/reviews',
    component: ProductsReviewsComponent,
    pathMatch: 'full'
  },
  {
    path: ':id/questions',
    component: ProductsQuestionsComponent
  },
  {
    path: ':id',
    component: ProductsFormComponent
  },
  {
    path: ':id/elabel',
    component: ProductsElabelComponent
  },
  {
    path: ':id/stores',
    component: ProductsStoresComponent
  },
  {
    path: ':id/documents',
    component: ProductsDocumentsComponent
  },
  {
    path: ':id/distributors',
    component: ProductsDistributorsComponent
  },
  {
    path: ':id/analytics',
    component: ProductsAnalyticsComponent
  },
  {
    path: ':id/loyalty',
    component: ProductLoyaltyComponent
  },
  {
    path: ':id/setting',
    component: ProductsSettingComponent,
  },
  {
    path: ':id/history',
    component: ProductsHistoryComponent
  },
  {
    path: ':id/elabel-history',
    component: ProductsElabelHistoryComponent
  },
  // {
  //   path: ':id',
  //   component: ProductsDetailComponent,
  // }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductsRoutingModule { }

